export default {
  'pages.register.title': 'Sign up',
  'pages.register.brand': 'Liulian AI',
  'pages.register.subtitle': 'Create an account and start creating with AI',
  'pages.register.accountRegister.tab': 'Account',
  'pages.register.emailRegister.tab': 'Email code',
  'pages.register.username.placeholder': 'Username',
  'pages.register.username.required': 'Please enter username',
  'pages.register.username.length': 'Username must be 4-15 characters',
  'pages.register.password.placeholder': 'Password',
  'pages.register.password.required': 'Please enter password',
  'pages.register.password.length': 'Password must be 4-20 characters',
  'pages.register.confirmPassword.placeholder': 'Confirm password',
  'pages.register.confirmPassword.required': 'Please confirm your password',
  'pages.register.confirmPassword.mismatch': 'Passwords do not match',
  'pages.register.inviterId.placeholder': 'Invitation code (optional)',
  'pages.register.inviterId.invalid': 'Invitation code must be a positive integer',
  'pages.register.email.placeholder': 'Email',
  'pages.register.email.required': 'Please enter email',
  'pages.register.email.invalid': 'Invalid email address',
  'pages.register.captcha.placeholder': 'Verification code',
  'pages.register.captcha.required': 'Please enter verification code',
  'pages.register.captcha.get': 'Get code',
  'pages.register.captcha.sent': 'Verification code sent to your email',
  'pages.register.captcha.sendFailed': 'Failed to send verification code. Please try again.',
  'pages.register.agreement': 'I agree to the Terms of Service',
  'pages.register.agreement.required': 'Please accept the Terms of Service',
  'pages.register.submit': 'Sign up',
  'pages.register.success': 'Registration successful. Please sign in.',
  'pages.register.failure': 'Registration failed. Please try again.',
  'pages.register.accountRegister.errorMessage': 'Registration failed. Check your account details.',
  'pages.register.emailRegister.errorMessage': 'Registration failed. Check email or verification code.',
  'pages.register.backHome': 'Back to home',
  'pages.register.hasAccount': 'Already have an account? {login}',
  'pages.register.loginNow': 'Sign in now',
};
